import { render, staticRenderFns } from "./pageIndex.vue?vue&type=template&id=ead0e2a0&scoped=true"
import script from "./pageIndex.vue?vue&type=script&lang=js"
export * from "./pageIndex.vue?vue&type=script&lang=js"
import style0 from "./pageIndex.vue?vue&type=style&index=0&id=ead0e2a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead0e2a0",
  null
  
)

export default component.exports